import Api from "../../../services/api";
import * as types from "../../types";

export function getCboJobsType(cb) {
    return (dispatch) => {
        Api.get('/w17f2180/Load-cbo-jobs-type')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(getCboJobsTypeSuccess(result?.data));
                }
            });
    };
}

function getCboJobsTypeSuccess(data) {
    return {
        type: types.W17_W17F2000_GET_CBO_JOBS_TYPE_SUCCESS,
        data
    };
}

export function loadGrid(params, cb) {
    return () => {
        Api.put('/w17f2180/Load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function updateEmployeeStatus(params, cb) {
    return () => {
        Api.put('/w17f2180/update-employee-status', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function createJobs(params, cb) {
    return () => {
        Api.post('/w17f2180/create-jobs', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function closeJobs(params, cb) {
    return () => {
        Api.put('/w17f2180/close-jobs', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboEmployee(cb) {
    return (dispatch) => {
        Api.get('/w17f2180/Load-cbo-employee')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadCboEmployeeSuccess(result?.data));
                }
            });
    };
}

function loadCboEmployeeSuccess(data) {
    return {
        type: types.W17_W17F2000_LOAD_CBO_EMPLOYEE_SUCCESS,
        data
    };
}

export function loadStrCustomer(params, cb) {
    return () => {
        Api.put('/w17f2180/Load-cbo-customer', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}


